import { render, staticRenderFns } from "./MPNResearchDetailV2.vue?vue&type=template&id=a5cf188c&scoped=true"
import script from "./MPNResearchDetailV2.vue?vue&type=script&lang=js"
export * from "./MPNResearchDetailV2.vue?vue&type=script&lang=js"
import style0 from "./MPNResearchDetailV2.vue?vue&type=style&index=0&id=a5cf188c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cf188c",
  null
  
)

export default component.exports